/*
 * WORKABLE Core and Accenture Edition design tokens.
 *
 * Source: bwllaming/brand-and-design c33327a0
 *   workable/html/website/assets/brand.css
 *
 * Do not edit by hand. Changes to the brand source must be re-copied here
 * and the source SHA updated in this header.
 */

@font-face {
  font-family: Archivo;
  src: url(/fonts/Archivo-variable.woff2) format("woff2");
  font-weight: 100 900;
  font-display: swap;
}
@font-face {
  font-family: Inter;
  src: url(/fonts/Inter-variable.woff2) format("woff2");
  font-weight: 100 900;
  font-display: swap;
}

:root {
  /* Core tokens */
  --paper: #F4F6F8;
  --surface: #fff;
  --wash: #E9EDF1;
  --ink: #141922;
  --muted: #546070;
  --line: #CBD1D8;
  --brand: #141922;
  --action: #141922;
  --action-ink: #fff;
  --brandwash: #E9EDF1;
  --signal: #EF4E2F;
  --focus: #005EA8;
  --success: #176A4A;
  --warning: #815A11;
  --display: Archivo, Arial, sans-serif;
  --body: Inter, system-ui, sans-serif;
  --mono: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  --hero: #141922;
  --hero-text: #F4F6F8;
  color-scheme: light;
}

:root[data-edition="accenture"],
[data-edition="accenture"] {
  --brand: #A100FF;
  --action: #7500C0;
  --brandwash: #F7ECFF;
  --focus: #7500C0;
  --hero: #2D004A;
  --hero-text: #fff;
  --paper: #F7F7F8;
  --muted: #565662;
  --line: #DEDEE3;
}

@media (prefers-color-scheme: dark) {
  :root:not([data-theme="light"]) {
    --paper: #141922;
    --surface: #1C2430;
    --wash: #202A36;
    --ink: #F4F6F8;
    --muted: #B7C1CE;
    --line: #3E4856;
    --brand: #F4F6F8;
    --action: #F4F6F8;
    --action-ink: #141922;
    --brandwash: #202A36;
    --focus: #86C5FF;
    --success: #77D1A5;
    --warning: #E6C476;
    color-scheme: dark;
  }
  :root:not([data-theme="light"])[data-edition="accenture"],
  :root:not([data-theme="light"]) [data-edition="accenture"] {
    --paper: #131316;
    --surface: #1C1C20;
    --wash: #17171C;
    --line: #2C2C32;
    --brand: #C77CFF;
    --action: #C77CFF;
    --action-ink: #15151B;
    --brandwash: #251236;
    --muted: #C5C5CD;
    --focus: #C77CFF;
  }
}

:root[data-theme="dark"] {
  --paper: #141922;
  --surface: #1C2430;
  --wash: #202A36;
  --ink: #F4F6F8;
  --muted: #B7C1CE;
  --line: #3E4856;
  --brand: #F4F6F8;
  --action: #F4F6F8;
  --action-ink: #141922;
  --brandwash: #202A36;
  --focus: #86C5FF;
  --success: #77D1A5;
  --warning: #E6C476;
  color-scheme: dark;
}

:root[data-theme="dark"][data-edition="accenture"],
:root[data-theme="dark"] [data-edition="accenture"] {
  --paper: #131316;
  --surface: #1C1C20;
  --wash: #17171C;
  --line: #2C2C32;
  --brand: #C77CFF;
  --action: #C77CFF;
  --action-ink: #15151B;
  --brandwash: #251236;
  --muted: #C5C5CD;
  --focus: #C77CFF;
}

@media (prefers-reduced-motion: reduce) {
  *, *::before, *::after {
    animation: none !important;
    transition: none !important;
  }
}
